import { useIsFeatureFlagEnabled } from "@circle-react/hooks/UseCommunitySetting";
import type { CommunitySettings } from "@circle-react/types/CommunitySettings";

// Named accessors for the community-settings feature flags that gate Circle AI.
// Growth-owned `growth_circle_ai_*` flags live with the growth team and are not
// surfaced here.

type CommunitySettingsLike = Partial<CommunitySettings> | null | undefined;

export const useIsCircleAiEnabled = (): boolean =>
  useIsFeatureFlagEnabled("circle_ai_enabled");

export const useIsCircleAiBotsEnabled = (): boolean =>
  useIsFeatureFlagEnabled("circle_ai_bots_enabled");

export const useIsCircleAiDailyBriefEnabled = (): boolean =>
  useIsFeatureFlagEnabled("circle_ai_daily_brief_enabled");

export const useIsCircleAiDebugPanelEnabled = (): boolean =>
  useIsFeatureFlagEnabled("circle_ai_debug_panel_enabled");

export const useIsCircleAiCreditsManagementEnabled = (): boolean =>
  useIsFeatureFlagEnabled("circle_ai_credits_management_enabled");

export const useIsAgents2BillingEnabled = (): boolean =>
  useIsFeatureFlagEnabled("agents_2_billing_enabled");

// Pure predicate: `useIsCircleAiOnboardingEnabled` composes this with the Circle
// 4.0 / experimentation checks against an already-loaded settings object.
export const isCircleAiOnboardingSettingEnabled = (
  settings: CommunitySettingsLike,
): boolean => Boolean(settings?.circle_ai_onboarding_enabled);
